import {ReactComponent as CautionRoundedIcon} from './cautionRounded.svg'

function CautionRounded() {
  return <CautionRoundedIcon />
}

export default CautionRounded
